import styled from 'styled-components';

export const IconHasTooltipStyled = styled.div`
  .Polaris-Icon:hover svg {
    fill: var(--p-color-text-interactive-hover);
  }
  span:hover > .wrap-icon > svg > path {
    fill: #000;
  }
`;
